import { c as _c } from "react/compiler-runtime";
import { CircleSpinnerInline, colors } from '@newfront-insurance/core-ui';
import { LineOfCoverageStageFilter, type LineOfCoverageSelectInputMetadata } from '@newfront-insurance/coverage-api';
import type { SchemaInputControlCustomInputProps, CustomValue } from '@newfront-insurance/dsl-schema-ui';
import { Application } from '@newfront-insurance/dsl-schema-ui';
import type { JSX } from 'react';
import { LineOfCoverageCard } from '../../../components/line-of-coverage-card';
import { LineOfCoverageSelector } from '../../../features/line-of-coverage-selector';
import { useLinesOfCoverage } from '../../../queries/use-lines-of-coverage';
export type LineOfCoverageSelectInputValue = string[] | undefined;
export function LineOfCoverageSelectDslInput(t0) {
  const $ = _c(7);
  const {
    onChange,
    value,
    accountUuid,
    app,
    disabled,
    isCompact
  } = t0;
  const t1 = app === Application.QUOTING ? LineOfCoverageStageFilter.ALL : LineOfCoverageStageFilter.BOUNDED;
  let t2;
  if ($[0] !== accountUuid || $[1] !== disabled || $[2] !== isCompact || $[3] !== onChange || $[4] !== t1 || $[5] !== value) {
    t2 = <LineOfCoverageSelector onChange={onChange} accountUuid={accountUuid} initLineOfCoverageUuids={value} stage={t1} disabled={disabled} isCompact={isCompact} />;
    $[0] = accountUuid;
    $[1] = disabled;
    $[2] = isCompact;
    $[3] = onChange;
    $[4] = t1;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export const LineOfCoverageSelectDisplay: CustomValue<LineOfCoverageSelectInputValue, LineOfCoverageSelectInputMetadata
// eslint-disable-next-line react/function-component-definition
> = t0 => {
  const $ = _c(11);
  const {
    value,
    accountUuid
  } = t0;
  let t1;
  if ($[0] !== accountUuid || $[1] !== value) {
    t1 = {
      accountUuid,
      lineOfCoverageUuids: value,
      stage: LineOfCoverageStageFilter.ALL
    };
    $[0] = accountUuid;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: linesOfCoverages,
    isLoading
  } = useLinesOfCoverage(t1);
  if (!value || value.length === 0) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="my-1">-</div>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== isLoading) {
    t2 = isLoading && <CircleSpinnerInline label="Loading..." />;
    $[4] = isLoading;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== linesOfCoverages) {
    t3 = linesOfCoverages && <div className="flex flex-col gap-2">{linesOfCoverages.map(_temp)}</div>;
    $[6] = linesOfCoverages;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="my-1 flex min-w-10 flex-col">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(loc) {
  return <LineOfCoverageCard key={loc.uuid} lineOfCoverage={loc} isExpandable={true} defaultExpanded={false} cardProps={{
    hideBorder: true,
    backgroundColor: colors.steel[50]
  }} />;
}